import {
  startOfMonth,
  endOfMonth,
  subMonths,
  addMonths,
  format,
} from "date-fns";

const lastMonthToCurrentWeek = (value) => {
  const currentDate = new Date();

  // Calculate the start date of the month "value" months ago
  const startDate = startOfMonth(subMonths(currentDate, Number(value) - 1));

  // Calculate the end date of the current month
  const endDate = endOfMonth(currentDate);

  const formattedStartDate = format(startDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");
  const dates = { formattedStartDate, formattedEndDate };
  return dates;
};

const currentMonthToNextMonth = (value) => {
  const currentDate = new Date();

  // Calculate the start date of the current month
  const startDate = startOfMonth(currentDate);

  // Calculate the end date of the Nth month in the future
  const endDate = endOfMonth(addMonths(currentDate, Number(value) - 1));

  const formattedStartDate = format(startDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");
  const dates = { formattedStartDate, formattedEndDate };
  return dates;
};

const fromThisMonthToThisMonth = (value) => {
  const currentDate = new Date();

  let startDate;
  let endDate;

  if (value === "Last Month") {
    startDate = startOfMonth(subMonths(currentDate, 1)); // Subtract 1 month
    endDate = endOfMonth(subMonths(currentDate, 1)); // End of the last month
  } else if (value === "This Month") {
    startDate = startOfMonth(currentDate); // Start of this month
    endDate = endOfMonth(currentDate); // End of this month
  } else if (value === "Next Month") {
    startDate = startOfMonth(addMonths(currentDate, 1)); // Start of the next month
    endDate = endOfMonth(addMonths(currentDate, 1)); // End of the next month
  } else {
    console.error(
      "Invalid value, please use 'Last Month', 'This Month', or 'Next Month'"
    );
  }

  // Format the dates
  if (startDate && endDate) {
    const formattedStartDate = format(startDate, "dd/MM/yyyy");
    const formattedEndDate = format(endDate, "dd/MM/yyyy");
    return { formattedStartDate, formattedEndDate };
  } else {
    // console.log("start and end date is undefined");
  }
};

export {
  lastMonthToCurrentWeek,
  currentMonthToNextMonth,
  fromThisMonthToThisMonth,
};
